export default __webpack_public_path__ + "img/138e70e10455c1de1205d9109e54f8c2.svg";